const accountUrl = window.location.href;
if(accountUrl.includes("account") || accountUrl.includes("addresses") || accountUrl.includes("wishlist")){
function eventListners() {
  // Update sidenav active state based on URL
  const sideNavLinksDesktop = document.querySelectorAll(".account-links-list.account-nav > *");
  const accountPages = document.querySelectorAll(".account-pages");
  const headerHeight = document.querySelector(".section--header").clientHeight;
  const footerHeight = document.querySelector(".section--footer").clientHeight;
  const currentUrl = window.location.pathname + window.location.search;
  var counter = 0;
  var counter1 = 0;
  var counter2 = 0;
  document.querySelector("#MainContent").style.minHeight =
    eval(window.innerHeight - headerHeight) + "px";
  if (currentUrl.includes("/account/orders/")) {
    document
      .querySelector(
        '.account-links-list.account-nav [data-href="/account?orders"]'
      )
      .classList.add("active");
  }

  sideNavLinksDesktop.forEach((link, index) => {
    var link_url = link.getAttribute("data-href");
    if (currentUrl == link_url || currentUrl.includes("/account?analytics") && counter == 0) {
      link.classList.add("active");
      counter = 1
    }
  });

  accountPages.forEach((link) => {
    var link_url = link.getAttribute("data-href");
    if (currentUrl == link_url || currentUrl.includes("/account?analytics") && counter1 == 0) {
      link.classList.add("active");
      counter1 = 1;
    }
  });
  
  var editAddress = document.querySelectorAll(".address-actions .edit");
  editAddress?.forEach((item) => {
    item.addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      item.closest(".address-grid-item").querySelector(".edit-address").classList.add("active");
      document.querySelector("body").classList.add("overflow-hidden");
      document.querySelector(".account-links-list").classList.remove("active");
    });
  });
  document.querySelectorAll(".remove").forEach((item) => {
    item.addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      item
        .closest(".address-grid-item")
        .querySelector("form.address-delete-form")
        .submit();
    });
  });

  document.querySelectorAll(".add-shipping-address").forEach((item) => {
    item.addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      document.querySelector(".add-address").classList.add("active");
      document.querySelector("body").classList.add("overflow-hidden");
      document.querySelector(".account-links-list").classList.remove("active");
    });
  });
  document.querySelectorAll(".close-address-drawer").forEach((item) => {
    item.addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      item.closest(".address-container").classList.remove("active");
      document.querySelector("body").classList.remove("overflow-hidden");
    });
  });

  document.querySelectorAll(".share-wishlist-toggle").forEach((item) => {
    console.log(item, "itemmssss");
    item.addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      document.querySelector("body").classList.add("overflow-hidden");
    });
  });
  document.querySelectorAll(".close-wishlist-drawer").forEach((item) => {
    item.addEventListener("click", (event) => {
      //handle click
      event.preventDefault();
      document.querySelector("body").classList.remove("overflow-hidden");
    });
  });

  if (window.innerWidth < 768) {
    let headerHeight = document.querySelector(".header-wrapper").offsetHeight;
    let accountNavHeight = document.querySelector(
      ".account-dashboard-top"
    ).offsetHeight;

    // document.querySelectorAll(".address-container").forEach((item) => {
    //   item.style.top = headerHeight + "px";
    // });
  }
  
  window.addEventListener("resize", function(event) {
    let top = "0px"
    if (document.body.clientWidth < 768) {
      let headerHeight = document.querySelector(".header-wrapper").offsetHeight;
      let accountNavHeight = document.querySelector(
        ".account-dashboard-top"
      ).offsetHeight;
  
      top = headerHeight + accountNavHeight + "px";
    }

    if(document.body.clientWidth > 768) {
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  })

  const anchorChildren = document.querySelectorAll(".account-links-list a > span");

  anchorChildren.forEach(function (child) {
    child.addEventListener("click", function (event) {
      event.stopPropagation(); // stop the click event from bubbling up to the parent anchor
    });
  });
}

document.addEventListener('click', function(event) {
  const elementToKeepVisible = event.target.closest('.address-container-inner');
  console.log(elementToKeepVisible, "elementToKeepVisible");
  
  if(event.target.getAttribute("edit-shipping-address") != null || 
    event.target.getAttribute("add-shipping-address") != null ) {
    return
  }
  if (elementToKeepVisible == null || !elementToKeepVisible?.contains(event.target)) {
    // Hide the element if it is not the element you want to keep visible
    document.querySelector(".main-address")?.
    querySelectorAll(".address-container.active").
    forEach((item, index) => {
        item.classList.remove("active");

        document.querySelector("body").
        classList.
        remove("overflow-hidden");
    })
    document.querySelector("body").classList.remove("overflow-hidden");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // do something here ...
  eventListners();
});

const resetPasswordElement = document.getElementById("personal-reset_password");
if(resetPasswordElement != null){

  resetPasswordElement.addEventListener('click', function(){
    const resetForm = document.querySelector('.reset_password_wrapper');
    resetForm.classList.remove('hide');

    const personalDetails = document.querySelector('.personal-detail__wrapper');
    personalDetails.classList.add('hide');

    const welcomeDetails = document.querySelector('.welcome-detail__wrapper');
    resetForm.classList.remove('show');
    welcomeDetails.classList.add('hide');
    
  });
}
}